import keyMirror from 'keymirror';

export const selectBookActionTypes = keyMirror({
	GET_SUBJECT_DETAILS_OF_USER: null,
	GET_SUBJECT_DETAILS_OF_USER_SUCCESS: null,
	GET_SUBJECT_DETAILS_OF_USER_ERROR: null,

	GET_SELECT_BOOK: null,
	GET_SELECT_BOOK_SUCCESS: null,
	GET_SELECT_BOOK_ERROR: null,
	CHANGE_SELECT_BOOK_FILTERS: null,

	ADD_SELECTION: null,
	ADD_SELECTION_ERROR: null,

	TOGGLE_SELECT_BOOK_MODAL: null,

	SET_SBM_INFO: null,
	SBM_GET_EDUCATION_TYPES: null,
	SBM_GET_EDUCATION_TYPES_SUCCESS: null,
	SBM_GET_EDUCATION_TYPES_ERROR: null,
	SBM_GET_SCHOOL: null,
	SBM_GET_SCHOOL_SUCCESS: null,
	SBM_GET_SCHOOL_ERROR: null,
	SBM_GET_USER_DETAILS: null,
	SBM_GET_USER_DETAILS_SUCCESS: null,
	SBM_GET_USER_DETAILS_ERROR: null,

	CREATE_GROUP_REQUEST: null,
	CREATE_GROUP_SUCCESS: null,
	CREATE_GROUP_ERROR: null,
	GET_AVAILABLE_SUBJECTS_REQUEST: null,
	GET_AVAILABLE_SUBJECTS_SUCCESS: null,
	GET_AVAILABLE_SUBJECTS_ERROR: null,

	SET_CANDIDATE_BOOK: null,
	SET_CANDIDATE_BOOK_SUCCESS: null,
	SET_CANDIDATE_BOOK_ERROR: null,

	CLEAN_SELECT_BOOK_STATE: null,
	SET_LOCATION: null,
});

export const getModalTabs = (t) => [
	{ title: t('modals.select_book_modal.tabs.subjects'), index: 0 },
	{ title: t('modals.select_book_modal.tabs.to_request'), index: 1 },
	{ title: t('modals.select_book_modal.tabs.create_list'), index: 2 },
];

export const getModalTabsWithoutTopics = (t) => [
	{ title: t('modals.select_book_modal.tabs.to_request'), index: 0 },
	{ title: t('modals.select_book_modal.tabs.create_list'), index: 1 },
];

export const editionOptions = Array.from(Array(10)).map((item, index) => ({
	title: index + 1,
	id: index + 1,
}));

export const SELECT_BOOK_MODAL_FORM = 'SelectBookModalForm';
